import { c as _c } from "react/compiler-runtime";
import { DropdownMenuRadioGroup, DropdownMenuRadioItem } from "@/components/ui/dropdown-menu";
import type { PriceBucket } from "@/lib/utils/price-buckets";
import { findMatchingBucket } from "@/lib/utils/price-buckets";
import type { ActiveFilters } from "@/types/filters";
interface PriceDropdownContentProps {
  priceBuckets: PriceBucket[];
  activeFilters: ActiveFilters;
  onPriceChange: (min?: number, max?: number) => void;
}
export function PriceDropdownContent(t0) {
  const $ = _c(13);
  const {
    priceBuckets,
    activeFilters,
    onPriceChange
  } = t0;
  let t1;
  if ($[0] !== activeFilters.priceMax || $[1] !== activeFilters.priceMin || $[2] !== priceBuckets) {
    t1 = findMatchingBucket(priceBuckets, activeFilters.priceMin, activeFilters.priceMax);
    $[0] = activeFilters.priceMax;
    $[1] = activeFilters.priceMin;
    $[2] = priceBuckets;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedBucket = t1;
  const t2 = selectedBucket?.id ?? "";
  let t3;
  if ($[4] !== onPriceChange || $[5] !== priceBuckets) {
    t3 = value => {
      if (!value) {
        onPriceChange(undefined, undefined);
      } else {
        const bucket = priceBuckets.find(b => b.id === value);
        if (bucket) {
          onPriceChange(bucket.min, bucket.max);
        }
      }
    };
    $[4] = onPriceChange;
    $[5] = priceBuckets;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== priceBuckets) {
    t4 = priceBuckets.map(_temp2);
    $[7] = priceBuckets;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <DropdownMenuRadioGroup value={t2} onValueChange={t3}>{t4}</DropdownMenuRadioGroup>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp2(bucket_0) {
  return <DropdownMenuRadioItem key={bucket_0.id} value={bucket_0.id} onSelect={_temp}>{bucket_0.label}</DropdownMenuRadioItem>;
}
function _temp(e) {
  return e.preventDefault();
}